import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const accountManagementAdminAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AccountManagementAdminPanel, Permission.AdminAccountManagement],
}
